import React from 'react';
import OrgCardSkeleton from './OrgCardSkeleton';

interface OrgDirectoryGridSkeletonProps {
  count?: number;
}

const OrgDirectoryGridSkeleton: React.FC<OrgDirectoryGridSkeletonProps> = ({ 
  count = 12 
}) => {
  return (
    <div
            className="md:grid gap-8 mb-8 w-full min-h-[400px] relative transition-all duration-300 ease-in-out"
      style={{
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 360px))',
        justifyContent: 'center'
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div 
          key={index}
          className="animate-in fade-in-0 duration-300"
        >
          <OrgCardSkeleton />
        </div>
      ))}
    </div>
  );
};

export default OrgDirectoryGridSkeleton;
